import CreativesList from './CreativesList';

export default CreativesList;
